var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterContentChecked, ChangeDetectorRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from "util";
import { BaseComponent } from '../../../common/components/base.component';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { WaterFallContainerComponent } from '../../../common/components/water.fall.container/water.fall.container.component';
import { clone } from '../../../common/extensions';
import { AuthService } from '../../../common/services/auth.service';
import { HubCustomBtn } from '../../../models/hub/hub.custom.btn';
import { CustomizationApiService } from '../../../services/customization.api.service';
import { HubApiService } from '../../../services/hub.api.service';
import { CustomBtnStore, EditorChoiceStore, HubCalendarEventsStore, HubCalendarPlacesStore, HubCalendarStore, ToggleStore, ToursStore } from '../../../stores/hub.calendar.store';
import { localStorageKeys } from "../../../common/constants/local.storage.keys";
var HubCalendarComponent = /** @class */ (function (_super) {
    __extends(HubCalendarComponent, _super);
    function HubCalendarComponent(router, activatedRoute, authService, hubCalendarStore, togglesStore, toursStore, customBtnStore, editorChoiceStore, hubCalendarEventsStore, hubCalendarPlacesStore, hubApiService, customizationApiService, changeDetector) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.authService = authService;
        _this.hubCalendarStore = hubCalendarStore;
        _this.togglesStore = togglesStore;
        _this.toursStore = toursStore;
        _this.customBtnStore = customBtnStore;
        _this.editorChoiceStore = editorChoiceStore;
        _this.hubCalendarEventsStore = hubCalendarEventsStore;
        _this.hubCalendarPlacesStore = hubCalendarPlacesStore;
        _this.hubApiService = hubApiService;
        _this.customizationApiService = customizationApiService;
        _this.changeDetector = changeDetector;
        _this.events = [];
        _this.places = [];
        _this.isNoContent = false;
        _this.featuresToggle = {
            itinerary: false
        };
        _this.customBtns = new HubCustomBtn();
        _this.allowedCategories = [];
        return _this;
    }
    HubCalendarComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        localStorage.removeItem(localStorageKeys.allowedPlaceCategories);
        this.toursStore.toursCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (tours) {
            _this.tours = tours || [];
        });
        this.togglesStore.toggleCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (toggle) {
            if (toggle) {
                _this.featuresToggle.itinerary = isNullOrUndefined(toggle.itinerary) ? true : toggle.itinerary;
            }
        });
        this.customBtnStore.customBtnCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (btns) {
            _this.customBtns = btns || new HubCustomBtn();
        });
        this.hubCalendarStore.actionCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            // if (!!this.actionCommand && this.actionCommand.isEventCalendar !== command.isEventCalendar) {
            //     return;
            // }
            _this.showSpinner();
            _this.actionCommand = clone(command);
            _this.isNoContent = false;
            _this.waterFallContainer.startLoading();
            console.log('command.noFilter', command.queryParams.noFilter);
            if (command.queryParams.noFilter && !localStorage.getItem(localStorageKeys.allowedPlaceCategories)) {
                _this.getAllowedPlaceCategories();
            }
            if (command.isEventCalendar) {
                _this.getEvents();
            }
            else {
                _this.getPlaces();
            }
        });
    };
    HubCalendarComponent.prototype.loadMore = function () {
        this.actionCommand.queryParams.page++;
        if (this.actionCommand.isEventCalendar) {
            this.getEvents(true);
        }
        else {
            this.getPlaces(true);
        }
    };
    HubCalendarComponent.prototype.getEvents = function (isLoadMore) {
        var _this = this;
        if (isLoadMore === void 0) { isLoadMore = false; }
        this.isAllDataLoaded = false;
        this.hubApiService.getEvents(this.hubName, this.actionCommand.queryParams)
            .subscribe(function (data) {
            data = data.filter(function (x) { return x.isApproved == _this.actionCommand.queryParams.isApproved; });
            if (!isLoadMore) {
                _this.events = data;
            }
            else {
                _this.events = _this.events.concat(data);
            }
            _this.hubCalendarEventsStore.eventsCommand.next(_this.events);
            if (!data || data.length === 0) {
                _this.isAllDataLoaded = true;
            }
            _this.waterFallContainer.reLayout();
            if (!_this.events.length) {
                _this.isNoContent = true;
            }
            setTimeout(function () {
                _this.hideSpinner();
            });
        });
    };
    HubCalendarComponent.prototype.ngAfterContentChecked = function () {
        this.changeDetector.detectChanges();
    };
    HubCalendarComponent.prototype.getPlaces = function (isLoadMore) {
        var _this = this;
        if (isLoadMore === void 0) { isLoadMore = false; }
        this.isAllDataLoaded = false;
        // this.actionCommand.queryParams.isManuallyCreated = this.actionCommand.queryParams.isManuallyCreated;
        this.hubApiService.getPlaces(this.hubName, this.actionCommand.queryParams)
            .subscribe(function (data) {
            if (!isLoadMore) {
                _this.places = data;
            }
            else {
                _this.places = _this.places.concat(data);
            }
            _this.hubCalendarPlacesStore.placesCommand.next(_this.places);
            if (!data || data.length === 0) {
                _this.isAllDataLoaded = true;
            }
            _this.waterFallContainer.reLayout();
            _this.hideSpinner();
            if (!_this.places.length) {
                _this.isNoContent = true;
            }
        });
    };
    HubCalendarComponent.prototype.getAllowedPlaceCategories = function () {
        var _this = this;
        this.hubApiService.getAllowedPlaceCategories(this.hubName).subscribe(function (data) {
            _this.allowedCategories = data;
            localStorage.setItem(localStorageKeys.allowedPlaceCategories, data.join(','));
        });
    };
    HubCalendarComponent.prototype.notAllowed = function (place) {
        return !this.allowedCategories.any(function (x) { return place.categoryList.any(function (y) { return x === y; }); });
    };
    HubCalendarComponent.prototype.pinEvent = function (event) {
        event.pinnedTime = new Date();
        this.events.splice(this.events.indexOf(event), 1);
        this.events.unshift(event);
        this.waterFallContainer.reLayout();
    };
    HubCalendarComponent.prototype.unPinEvent = function (event) {
        var _this = this;
        this.hubApiService.getEvents(this.hubName, this.actionCommand.queryParams)
            .subscribe(function (data) {
            _this.events = data;
            _this.waterFallContainer.reLayout();
        });
    };
    HubCalendarComponent.prototype.removeEvent = function (event, isRemoveSameOwnerEvents) {
        if (isRemoveSameOwnerEvents === void 0) { isRemoveSameOwnerEvents = false; }
        this.events.splice(this.events.indexOf(event), 1);
        if (this.events && this.events.length > 0) {
            for (var i = this.events.length - 1; i >= 0; i--) {
                if (isRemoveSameOwnerEvents && this.isSameOwner(this.events[i], event)) {
                    this.events.splice(i, 1);
                }
            }
        }
        this.waterFallContainer.reLayout();
    };
    HubCalendarComponent.prototype.isSameOwner = function (event1, event2) {
        if (!event1.owner)
            return false;
        if (!event2.owner)
            return false;
        if (!event1.owner.id && !event1.owner.name)
            return false;
        if (!event2.owner.id && !event2.owner.name)
            return false;
        return (event1.owner.id && event2.owner.id && event1.owner.id === event2.owner.id) || (event1.owner.name && event2.owner.name && event1.owner.name === event2.owner.name);
    };
    HubCalendarComponent.prototype.pinPlace = function (place) {
        place.pinnedTime = new Date();
        this.places.splice(this.places.indexOf(place), 1);
        this.places.unshift(place);
        this.waterFallContainer.reLayout();
    };
    HubCalendarComponent.prototype.unPinPlace = function (place) {
        var _this = this;
        this.hubApiService.getPlaces(this.hubName, this.actionCommand.queryParams)
            .subscribe(function (data) {
            _this.places = data;
            _this.waterFallContainer.reLayout();
        });
    };
    HubCalendarComponent.prototype.removePlace = function (place) {
        this.places.splice(this.places.indexOf(place), 1);
        this.waterFallContainer.reLayout();
    };
    HubCalendarComponent.prototype.showSpinner = function () {
        this.isLoading = true;
        this.spinner.show();
    };
    HubCalendarComponent.prototype.hideSpinner = function () {
        var _this = this;
        setTimeout(function () {
            _this.isLoading = false;
            _this.spinner.hide();
        });
    };
    return HubCalendarComponent;
}(BaseComponent));
export { HubCalendarComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/calendar/hub.calendar.component.ts.pre-build-optimizer.js